import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoints } from '@vueuse/core';
import UiModal from './ui/UiModal.vue';

interface Props {
  shops: any[];
}

type ShopsModalType = InstanceType<typeof UiModal>;


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductShops',
  props: {
    shops: null
  },
  setup(__props: any) {

const props = __props as {
  shops: any[];
};



const breakpoints = useBreakpoints({
  sm: 640,
  md: 992,
  lg: 1280,
  xl: 1656,
});
const lgAndLarger = breakpoints.greater('lg');

const shopsModal = ref<ShopsModalType | null>(null);

const getImage = (image?: string) =>
  image !== undefined && image !== '' ? image : '/img/shop1.jpg';
const isCollapsible = computed(() => props.shops.length > 4);
const isCollapsedItemsShowed = ref(false);
const renderedShops = computed(() => {
  if (!isCollapsible.value) return props.shops;
  if (isCollapsedItemsShowed.value) return props.shops;

  return props.shops.slice(0, 4);
});

const openShopsModal = (shopsModalRef: ShopsModalType | null) => {
  if (!shopsModalRef) return;
  shopsModalRef.open();
};

const toggleCollapsedItems = () => {
  isCollapsedItemsShowed.value = !isCollapsedItemsShowed.value;
};

const getClickHandlerFunction = () => {
  return !lgAndLarger.value
    ? toggleCollapsedItems()
    : openShopsModal(shopsModal.value);
};

watch(
  () => lgAndLarger.value,
  (newValue) => {
    // Reset isCollapsedItemsShowed to avoid state when full list is showed and modal can be opened on desktop
    newValue && (isCollapsedItemsShowed.value = false);
  },
);

return { __sfc: true,props, breakpoints, lgAndLarger, shopsModal, getImage, isCollapsible, isCollapsedItemsShowed, renderedShops, openShopsModal, toggleCollapsedItems, getClickHandlerFunction, CdnImg, UiModal }
}

})